import React from "react";
import { X } from "lucide-react";
import { GuideLink } from "./PortalShell";
import { FPED_STEPS, STEPS, stepOf } from "../../lib/portalHelp";

/**
 * "Cum folosești pagina asta" — the course in three steps, the one the group
 * is in marked (06.10.2026). Shown at the first visit until closed; the link
 * next to the title brings it back.
 */
export default function GroupIntro({ stage, onClose, fped = false }) {
  const steps = fped ? FPED_STEPS : STEPS;
  const now = stepOf(stage, steps);
  return (
    <section className="relative mt-6 rounded-2xl border border-[#965EA7]/25 bg-white p-5" aria-labelledby="portal-intro"
      data-testid="portal-intro">
      <button type="button" onClick={onClose} aria-label="Închide ghidul"
        className="absolute right-3 top-3 rounded-full p-1 text-[#9CA3AF] hover:text-[#373A45]">
        <X size={16} />
      </button>
      <h2 id="portal-intro" className="pr-8 font-display text-lg font-bold text-[#373A45]">Cum folosești pagina asta</h2>
      <p className="mt-1 text-sm text-[#6B7280]">
        {fped
          ? "Sus vezi unde e grupa și ce ai de făcut acum. Dedesubt, în file, găsești cursanții cu temele lor și "
            + "prezența. Un curs are trei pași:"
          : "Sus vezi unde e grupa și ce ai de făcut acum. Dedesubt, în file, găsești cursanții, prezența, portofoliile și "
            + "documentele. Un curs are trei pași:"}
      </p>
      <ol className="mt-4 grid gap-3 sm:grid-cols-3">
        {steps.map((s, i) => {
          const here = s.key === now;
          return (
            <li key={s.key} className={`rounded-xl border p-3 ${here ? "border-[#965EA7] bg-[#965EA7]/[0.05]" : "border-[#E5E7EB]"}`}
              aria-current={here ? "step" : undefined}>
              <p className="flex items-center gap-2 text-sm font-semibold text-[#373A45]">
                <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-full text-xs ${here ? "bg-[#965EA7] text-white" : "bg-[#F3F4F6] text-[#6B7280]"}`}>
                  {i + 1}
                </span>
                {s.title}
                {here && <span className="ml-auto text-[11px] font-semibold text-[#7A4986]">acum</span>}
              </p>
              <p className="mt-1.5 text-xs leading-relaxed text-[#6B7280]">{s.text}</p>
            </li>
          );
        })}
      </ol>
      <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2">
        <button type="button" onClick={onClose}
          className="rounded-full bg-[#965EA7] px-5 py-2 text-sm font-semibold text-white hover:bg-[#7A4986]">
          Am înțeles
        </button>
        <GuideLink>Citește mai mult în ghid</GuideLink>
      </div>
    </section>
  );
}
